import { FEATURES } from '@constants/Text'
import * as professionalsStore from './store'

export const PERMISSION = FEATURES.PROFESSIONALS

export const IS_BETA_PERMISSIONS = true
export const IS_BETA_PROFESSIONAL_PAGES = false
// Logica para apresentar configuracao de bonificação
export const PERMISSION_BONIFICATION = FEATURES.BONIFICATION

export function professionalsModule({ store }) {
  store.registerModule('professionals', {
    ...professionalsStore,
    namespaced: true,
  })
}
